interface ActionCreator<A, P extends any[] = any[]> {
  (...args: P): A;
}
interface ActionCreatorsMapObject<A = any, P extends any[] = any[]> {
  [key: string]: ActionCreator<A, P>;
}

export function bindActionCreators<
  T extends ActionCreatorsMapObject,
  K extends React.Dispatch<any>
>(actionCreators: T, dispatch: K) {
  return Object.entries(actionCreators).reduce((acum, [key, value]) => {
    if (typeof actionCreators !== 'object' || actionCreators === null) {
      throw new Error(
        `bindActionCreators expected an object, instead received ${
          actionCreators === null ? 'null' : typeof actionCreators
        }. ` +
          `Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`
      );
    }
    return {
      ...acum,
      [key](this: any, ...args: any[]) {
        return dispatch(value.apply(this, args));
      },
    };
  }, {} as T);
}
